<script setup lang="ts">

</script>

<template>
  <div class="mt-8 mb-8">
    <a href="/epk" target="_blank">View EPK</a>
  </div>
</template>